<app-header [ngClass]="{'sticky' : isSticky}"></app-header>

<router-outlet></router-outlet>

<app-footer></app-footer>

<div [ngClass]="{'to_top' : toTop}" (click)="scrollToTop()"></div>